import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Atalaya · Ciberseguridad',
    description: 'Tablero ejecutivo de ciberseguridad que se genera a partir de tu base en Excel, leída de forma local en el navegador.',
    descriptionEn: 'Executive cybersecurity dashboard built from your Excel database, read locally in the browser.',
    url: getOrigin()
}
